import { Keyboard } from 'react-native';

/**
 * Wraps a New Task footer action so the text fields give up focus before it
 * runs.
 *
 * Uploading a file or photo, taking one, picking a due date and choosing an
 * assignee all hand the user off to something that is not a text field. With
 * the keyboard still up it covers the picker, and the sheet keeps the extra
 * height it reserved for a keyboard nobody is typing on (TA-10495 QA round 3).
 *
 * `Keyboard.dismiss()` blurs whichever input currently holds focus, so the
 * caller does not need a ref to the field — which matters here, because the
 * Description input's ref lives inside TaskCreateModalFormNew and the footer
 * actions do not have it.
 *
 * `openProjectModal` and `openDateModal` in TaskCreateBottomSheet already did
 * this inline; this exists so the remaining actions can do the same without
 * repeating it, and so the behaviour is testable without mounting the sheet.
 */
export const dismissKeyboardBefore = (run: () => void) => (): void => {
  Keyboard.dismiss();
  run();
};
